import { IIdentifiable } from '@/common/models/models'
import { AudioFile, IAudioFile } from '@/common/models/data/dashboard/media/audio-file'
import { IImage, Image } from '@/common/models/data/dashboard/media/image'

interface IPage extends IIdentifiable {
    page: string
    title: string
    content: string
    description: string
    keywords: string
    removable: boolean

    audio_files?: Array<IAudioFile>
    images?: Array<IImage>
}

class Page implements IPage {
    id = 0
    page = ''
    title = ''
    content = ''
    description = ''
    keywords = ''
    removable = true

    audio_files?: Array<IAudioFile> = []
    images?: Array<IImage> = []

    constructor (dto?: IPage) {
        if (dto) {
            this.id = dto.id
            this.page = dto.page
            this.title = dto.title
            this.content = dto.content
            this.description = dto.description
            this.keywords = dto.keywords
            this.removable = dto.removable

            this.audio_files = dto.audio_files?.map(audioFile => new AudioFile(audioFile))
            this.images = dto.images?.map(image => new Image(image))
        }
    }

    addAudioFile (audioFile: AudioFile): void {
        if (!this.audio_files) {
            this.audio_files = []
        }

        if (!this.audio_files.includes(audioFile)) {
            this.audio_files.push(audioFile)
        }
    }

    addImage (image: Image): void {
        if (!this.images) {
            this.images = []
        }

        if (!this.images.includes(image)) {
            this.images.push(image)
        }
    }
}

// TODO: Not pretty. Entire models directory needs refactor
type IPageRequest = Omit<IPage, 'id' | 'removable' | 'audio_files' | 'images'> & {
    audio_files: Array<number>
    images: Array<number>
}

export {
    IPage, IPageRequest, Page
}
